import { AppState, ExcalidrawProps, Point, UIAppState } from "../types";
import {
  getShortcutKey,
  sceneCoordsToViewportCoords,
  viewportCoordsToSceneCoords,
  wrapEvent,
} from "../utils";
import { getEmbedLink, embeddableURLValidator } from "./embeddable";
import { mutateElement } from "./mutateElement";
import {
  ExcalidrawEmbeddableElement,
  NonDeletedExcalidrawElement,
} from "./types";

import { register } from "../actions/register";
import { ToolButton } from "../components/ToolButton";
import { FreedrawIcon, LinkIcon, TrashIcon } from "../components/icons";
import { t } from "../i18n";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import clsx from "clsx";
import { KEYS } from "../keys";
import { DEFAULT_LINK_SIZE } from "../renderer/renderElement";
import { rotate } from "../math";
import { EVENT, HYPERLINK_TOOLTIP_DELAY, MIME_TYPES } from "../constants";
import { Bounds } from "./bounds";
import { getTooltipDiv, updateTooltipPosition } from "../components/Tooltip";
import { getSelectedElements } from "../scene";
import { isPointHittingElementBoundingBox } from "./collision";
import { getElementAbsoluteCoords } from ".";
import {isLocalLink, isValidUrl, normalizeLink} from "../data/url";

import "./Hyperlink.scss";
import { trackEvent } from "../analytics";
import { useAppProps, useExcalidrawAppState } from "../components/App";
import { isEmbeddableElement } from "./typeChecks";
import { ShapeCache } from "../scene/ShapeCache";
import {postMessage} from "../../../../src/common/event";
import {DRAW_LINK_CLICK} from "../../../../src/Const";
import {isDarkMode} from "../../../../src/utils";

const CONTAINER_WIDTH = 320;
const SPACE_BOTTOM = 85;
const CONTAINER_PADDING = 5;
const CONTAINER_HEIGHT = 42;
const AUTO_HIDE_TIMEOUT = 500;

export const getRotateImg = ()=>{
  const ROTATE_IMG = document.createElement("img");
  ROTATE_IMG.src = `data:${MIME_TYPES.svg}, ${encodeURIComponent(
      `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame 1321316835">
<g id="Group 427322944">
<rect id="Rectangle 34625540" width="30" height="30" rx="6.42857" fill="#D9D9D9" fill-opacity="0.01"/>
<g id="Frame" clip-path="url(#clip0_1_197)">
<path id="Vector" opacity="0.801" d="M9.29637 17.6536C9.2817 17.7447 9.29055 17.838 9.32209 17.9247C9.60478 19.2102 10.2792 20.3765 11.2525 21.2626C12.2258 22.1488 13.45 22.7113 14.7564 22.8725C18.2299 23.3172 21.4271 20.8357 21.8642 17.3354C21.9697 16.5025 21.9098 15.6571 21.688 14.8474C21.4663 14.0378 21.0869 13.2798 20.5718 12.617C20.0567 11.9541 19.4158 11.3994 18.686 10.9846C17.9561 10.5698 17.1516 10.3031 16.3185 10.1997C16.2339 10.1815 16.1224 10.1718 16.0292 10.1707C16.0678 9.81717 16.1149 9.48931 16.1449 9.20003C16.1932 8.8261 16.2414 8.54646 16.2414 8.45324C16.2703 8.35038 16.2617 8.22824 16.1878 8.14467C16.1629 8.10918 16.131 8.07914 16.094 8.05638C16.0571 8.03362 16.0159 8.01863 15.973 8.01231C15.9301 8.006 15.8864 8.00849 15.8445 8.01964C15.8025 8.03079 15.7633 8.05037 15.7292 8.07717L15.7207 8.09538L15.4571 8.33753L13.6014 9.78717L13.3389 9.98217L13.1139 10.1493C13.0389 10.205 13.0014 10.279 12.9821 10.3636C12.9743 10.4064 12.9761 10.4503 12.9872 10.4924C12.9983 10.5344 13.0185 10.5735 13.0464 10.6068L13.2135 10.8318L13.4085 11.0943L14.8571 12.95L15.0703 13.2222L15.0885 13.2318C15.146 13.2971 15.2261 13.3383 15.3127 13.3473C15.3992 13.3562 15.486 13.3322 15.5557 13.28C15.6403 13.205 15.6971 13.0936 15.6789 12.9907C15.6982 12.9072 15.7271 12.6179 15.7753 12.244C15.8139 11.9825 15.8524 11.675 15.891 11.3665C15.9853 11.3665 16.0871 11.3954 16.1803 11.3954C19.0196 11.7543 21.0542 14.3515 20.6964 17.1897C20.3374 20.029 17.7403 22.0636 14.9021 21.7047C13.8217 21.5725 12.8104 21.1032 12.012 20.3635C11.2136 19.6237 10.6686 18.6511 10.4546 17.584C10.4256 17.4678 10.3619 17.3633 10.2719 17.2844C10.1819 17.2055 10.0699 17.156 9.95101 17.1425C9.6253 17.0943 9.31566 17.3354 9.2953 17.6536H9.29637Z" fill="${isDarkMode()?'#FFFFFF':'#393834'}"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_1_197">
<rect width="13" height="15" fill="white" transform="matrix(-1 0 0 1 22 8)"/>
</clipPath>
</defs>
</svg>
`,
  )}`;
  return ROTATE_IMG;
}


const getLinkSvg = ()=>{
  if (isDarkMode()){
    return `<svg width="20" height="21" viewBox="0 0 20 21" fill="#1E1E1E" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99349 18.8333C14.5959 18.8333 18.3268 15.1023 18.3268 10.5C18.3268 5.89758 14.5959 2.16663 9.99349 2.16663C5.39111 2.16663 1.66016 5.89758 1.66016 10.5C1.66016 15.1023 5.39111 18.8333 9.99349 18.8333Z" stroke="#3670F7" stroke-width="1.2" stroke-linejoin="round"/>
<path d="M6.24316 14.25L8.11816 8.625L13.7432 6.75L11.8682 12.375L6.24316 14.25Z" stroke="#3670F7" stroke-width="1.2" stroke-linejoin="round"/>
</svg>
`
  }
  return `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99349 18.8333C14.5959 18.8333 18.3268 15.1023 18.3268 10.5C18.3268 5.89758 14.5959 2.16663 9.99349 2.16663C5.39111 2.16663 1.66016 5.89758 1.66016 10.5C1.66016 15.1023 5.39111 18.8333 9.99349 18.8333Z" stroke="#3670F7" stroke-width="1.2" stroke-linejoin="round"/>
<path d="M6.24316 14.25L8.11816 8.625L13.7432 6.75L11.8682 12.375L6.24316 14.25Z" stroke="#3670F7" stroke-width="1.2" stroke-linejoin="round"/>
</svg>
`
}

export const EXTERNAL_LINK_IMG = document.createElement("img");
EXTERNAL_LINK_IMG.src = `data:${MIME_TYPES.svg}, ${encodeURIComponent(
  // `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1971c2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>`,
//     `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H19V12H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z" fill="#5289FF"/>
// </svg>`
//     `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g id="icon/pop/more">
// <rect id="Rectangle 34625540" x="0.00683594" width="20" height="20" rx="6.42857" fill="#D9D9D9" fill-opacity="0.01"/>
// <g id="Group 427322931">
// <circle id="Ellipse 2716" cx="9.97754" cy="9.823" r="8" stroke="#3670F7" stroke-width="1.2"/>
// <path id="Vector 1215" d="M10.0074 1.83286C10.0074 1.83286 6.31641 5.65527 6.31641 9.91705C6.31641 14.1788 10.0074 18.177 10.0074 18.177" stroke="#3670F7"/>
// <path id="Vector 1216" d="M10.0073 1.83286C10.0073 1.83286 13.6982 5.65527 13.6982 9.91705C13.6982 14.1788 10.0073 18.177 10.0073 18.177" stroke="#3670F7"/>
// <path id="Vector 1214" d="M10.0068 1.83286V18.177" stroke="#3670F7"/>
// <path id="Vector 1217" d="M1.83496 10.0049L18.1791 10.0049" stroke="#3670F7"/>
// <path id="Vector 1218" d="M4.2959 15.7108C4.2959 15.7108 5.70131 13.2921 9.98336 13.2921C14.2654 13.2921 15.6709 15.7108 15.6709 15.7108" stroke="#3670F7"/>
// <path id="Vector 1219" d="M4.2959 4.56454C4.2959 4.56454 5.70131 6.98321 9.98336 6.98321C14.2654 6.98321 15.6709 4.56455 15.6709 4.56455" stroke="#3670F7"/>
// </g>
// </g>
// </svg>`
    getLinkSvg()
)}`;


let IS_HYPERLINK_TOOLTIP_VISIBLE = false;

const embeddableLinkCache = new Map<
  ExcalidrawEmbeddableElement["id"],
  string
>();

export const Hyperlink = ({
  element,
  setAppState,
  onLinkOpen,
  setToast,
}: {
  element: NonDeletedExcalidrawElement;
  setAppState: React.Component<any, AppState>["setState"];
  onLinkOpen: ExcalidrawProps["onLinkOpen"];
  setToast: (
    toast: { message: string; closable?: boolean; duration?: number } | null,
  ) => void;
}) => {
  const appState = useExcalidrawAppState();
  const appProps = useAppProps();

  const linkVal = element.link || "";

  const [inputVal, setInputVal] = useState(linkVal);
  const inputRef = useRef<HTMLInputElement>(null);
  const isEditing = appState.showHyperlinkPopup === "editor";

  const handleSubmit = useCallback(() => {
    if (!inputRef.current) {
      return;
    }

    const link = normalizeLink(inputRef.current.value) || null;

    if (!element.link && link) {
      trackEvent("hyperlink", "create");
    }

    if (isEmbeddableElement(element)) {
      if (appState.activeEmbeddable?.element === element) {
        setAppState({ activeEmbeddable: null });
      }
      if (!link) {
        mutateElement(element, {
          validated: false,
          link: null,
        });
        return;
      }

      if (!embeddableURLValidator(link, appProps.validateEmbeddable)) {
        if (link) {
          setToast({ message: t("toast.unableToEmbed"), closable: true });
        }
        element.link && embeddableLinkCache.set(element.id, element.link);
        mutateElement(element, {
          validated: false,
          link,
        });
        ShapeCache.delete(element);
      } else {
        const { width, height } = element;
        const embedLink = getEmbedLink(link);
        if (embedLink?.warning) {
          setToast({ message: embedLink.warning, closable: true });
        }
        const ar = embedLink
          ? embedLink.intrinsicSize.w / embedLink.intrinsicSize.h
          : 1;
        const hasLinkChanged =
          embeddableLinkCache.get(element.id) !== element.link;
        mutateElement(element, {
          ...(hasLinkChanged
            ? {
                width:
                  embedLink?.type === "video"
                    ? width > height
                      ? width
                      : height * ar
                    : width,
                height:
                  embedLink?.type === "video"
                    ? width > height
                      ? width / ar
                      : height
                    : height,
              }
            : {}),
          validated: true,
          link,
        });
        ShapeCache.delete(element);
        if (embeddableLinkCache.has(element.id)) {
          embeddableLinkCache.delete(element.id);
        }
      }
    } else {
      mutateElement(element, { link });
    }
  }, [
    element,
    setToast,
    appProps.validateEmbeddable,
    appState.activeEmbeddable,
    setAppState,
  ]);

  useLayoutEffect(() => {
    return () => {
      handleSubmit();
    };
  }, [handleSubmit]);

  useEffect(() => {
    let timeoutId: number | null = null;
    const handlePointerMove = (event: PointerEvent) => {
      if (isEditing) {
        return;
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const shouldHide = shouldHideLinkPopup(element, appState, [
        event.clientX,
        event.clientY,
      ]) as boolean;
      if (shouldHide) {
        timeoutId = window.setTimeout(() => {
          setAppState({ showHyperlinkPopup: false });
        }, AUTO_HIDE_TIMEOUT);
      }
    };
    window.addEventListener(EVENT.POINTER_MOVE, handlePointerMove, false);
    return () => {
      window.removeEventListener(EVENT.POINTER_MOVE, handlePointerMove, false);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [appState, element, isEditing, setAppState]);

  const handleRemove = useCallback(() => {
    trackEvent("hyperlink", "delete");
    mutateElement(element, { link: null });
    if (isEditing) {
      inputRef.current!.value = "";
    }
    setAppState({ showHyperlinkPopup: false });
  }, [setAppState, element, isEditing]);

  const onEdit = () => {
    trackEvent("hyperlink", "edit", "popup-ui");
    setAppState({ showHyperlinkPopup: "editor" });
  };
  const { x, y } = getCoordsForPopover(element, appState);
  if (
    appState.contextMenu ||
    appState.draggingElement ||
    appState.resizingElement ||
    appState.isRotating ||
    appState.openMenu ||
    appState.viewModeEnabled
  ) {
    return null;
  }

  let isCustomLink = false;
  if(linkVal != undefined && linkVal != null && linkVal != ''){
    if(linkVal.startsWith("{")){
      try {
        const obj = JSON.parse(linkVal);
        if (obj != undefined){
          isCustomLink = true;
        }
      }catch (e) {

      }
    }
  }
  if(isCustomLink){
    return(
        <></>
    )
  }else {
    return (
        <div
            className="excalidraw-hyperlinkContainer"
            style={{
              display:'none',
              top: `${y}px`,
              left: `${x}px`,
              width: CONTAINER_WIDTH,
              padding: CONTAINER_PADDING,
            }}
            onClick={() => {
              if (!element.link && !isEditing) {
                setAppState({ showHyperlinkPopup: "editor" });
              }
            }}
        >
          {isEditing ? (
              <input
                  className={clsx("excalidraw-hyperlinkContainer-input")}
                  placeholder="Type or paste your link here"
                  ref={inputRef}
                  value={inputVal}
                  onChange={(event) => setInputVal(event.target.value)}
                  autoFocus
                  onKeyDown={(event) => {
                    event.stopPropagation();
                    // prevent cmd/ctrl+k shortcut when editing link
                    if (event[KEYS.CTRL_OR_CMD] && event.key === KEYS.K) {
                      event.preventDefault();
                    }
                    if (event.key === KEYS.ENTER || event.key === KEYS.ESCAPE) {
                      handleSubmit();
                      setAppState({ showHyperlinkPopup: "info" });
                    }
                  }}
              />
          ) : element.link ? (
              <a
                  href={normalizeLink(element.link || "")}
                  className="excalidraw-hyperlinkContainer-link"
                  target={isLocalLink(element.link) ? "_self" : "_blank"}
                  onClick={(event) => {
                    if (element.link && onLinkOpen) {
                      const customEvent = wrapEvent(
                          EVENT.EXCALIDRAW_LINK,
                          event.nativeEvent,
                      );
                      onLinkOpen(
                          {
                            ...element,
                            link: normalizeLink(element.link),
                          },
                          customEvent,
                      );
                      if (customEvent.defaultPrevented) {
                        event.preventDefault();
                      }
                    }
                  }}
                  rel="noopener noreferrer"
              >
                {element.link}
              </a>
          ) : (
              <div className="excalidraw-hyperlinkContainer-link">
                {t("labels.link.empty")}
              </div>
          )}
          <div className="excalidraw-hyperlinkContainer__buttons">
            {!isEditing && (
                <ToolButton
                    type="button"
                    title={t("buttons.edit")}
                    aria-label={t("buttons.edit")}
                    label={t("buttons.edit")}
                    onClick={onEdit}
                    className="excalidraw-hyperlinkContainer--edit"
                    icon={FreedrawIcon}
                />
            )}
            {linkVal && !isEmbeddableElement(element) && (
                <ToolButton
                    type="button"
                    title={t("buttons.remove")}
                    aria-label={t("buttons.remove")}
                    label={t("buttons.remove")}
                    onClick={handleRemove}
                    className="excalidraw-hyperlinkContainer--remove"
                    icon={TrashIcon}
                />
            )}
          </div>
        </div>
    );
  }
};

const getCoordsForPopover = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
) => {
  const [x1, y1] = getElementAbsoluteCoords(element);
  const { x: viewportX, y: viewportY } = sceneCoordsToViewportCoords(
    { sceneX: x1 + element.width / 2, sceneY: y1 },
    appState,
  );
  const x = viewportX - appState.offsetLeft - CONTAINER_WIDTH / 2;
  const y = viewportY - appState.offsetTop - SPACE_BOTTOM;
  return { x, y };
};

export const actionLink = register({
  name: "hyperlink",
  perform: (elements, appState) => {
    /*
    if (appState.showHyperlinkPopup === "editor") {
      return false;
    }

    return {
      elements,
      appState: {
        ...appState,
        showHyperlinkPopup: "editor",
        openMenu: null,
      },
      commitToHistory: true,
    };
     */
    postMessage(DRAW_LINK_CLICK);

    return {
      elements,
      appState: {
        ...appState,
        openMenu: null,
      },
      commitToHistory: true,
    };
  },
  trackEvent: { category: "hyperlink", action: "click" },
  keyTest: (event) => event[KEYS.CTRL_OR_CMD] && event.key === KEYS.K,
  contextItemLabel: (elements, appState) =>
    getContextMenuLabel(elements, appState),
  predicate: (elements, appState) => {
    const selectedElements = getSelectedElements(elements, appState);
    return selectedElements.length === 1;
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const selectedElements = getSelectedElements(elements, appState);

    return (
      <ToolButton
        type="button"
        icon={LinkIcon}
        aria-label={t(getContextMenuLabel(elements, appState))}
        title={`${
          isEmbeddableElement(elements[0])
            ? t("labels.link.labelEmbed")
            : t("labels.link.label")
        } - ${getShortcutKey("CtrlOrCmd+K")}`}
        onClick={() => updateData(null)}
        selected={selectedElements.length === 1 && !!selectedElements[0].link}
      />
    );
  },
});

export const getContextMenuLabel = (
  elements: readonly NonDeletedExcalidrawElement[],
  appState: AppState,
) => {
  const selectedElements = getSelectedElements(elements, appState);
  const label = selectedElements[0]!.link
    ? isEmbeddableElement(selectedElements[0])
      ? "labels.link.editEmbed"
      : "labels.link.edit"
    : isEmbeddableElement(selectedElements[0])
    ? "labels.link.createEmbed"
    : "labels.link.create";
  return label;
};

export const getLinkHandleFromCoords = (
  [x1, y1, x2, y2]: Bounds,
  angle: number,
  appState: Pick<UIAppState, "zoom">,
): Bounds => {
  const size = DEFAULT_LINK_SIZE;
  const linkWidth = size / appState.zoom.value;
  const linkHeight = size / appState.zoom.value;
  const linkMarginY = size / appState.zoom.value;
  const centerX = (x1 + x2) / 2;
  const centerY = (y1 + y2) / 2;
  const centeringOffset = (size - 8) / (2 * appState.zoom.value);
  const dashedLineMargin = 4 / appState.zoom.value;

  // Same as `ne` resize handle
  const x = x2 + dashedLineMargin - centeringOffset;
  const y = y1 - dashedLineMargin - linkMarginY + centeringOffset;

  const [rotatedX, rotatedY] = rotate(
    x + linkWidth / 2,
    y + linkHeight / 2,
    centerX,
    centerY,
    angle,
  );
  return [
    rotatedX - linkWidth / 2,
    rotatedY - linkHeight / 2,
    linkWidth,
    linkHeight,
  ];
};

export const getVideoNotesHandleFromCoords = (
    [x1, y1, x2, y2]: Bounds,
    angle: number,
    appState: Pick<UIAppState, "zoom">,
): Bounds => {
  const size = DEFAULT_LINK_SIZE;
  const linkWidth = size / appState.zoom.value;
  const linkHeight = size / appState.zoom.value;
  const linkMarginY = size / appState.zoom.value;
  const centerX = (x1 + x2) / 2;
  const centerY = (y1 + y2) / 2;
  const centeringOffset = (size - 8) / (2 * appState.zoom.value);
  const dashedLineMargin = 4 / appState.zoom.value;

  // Same as `ne` resize handle
  const x = x2 + dashedLineMargin - centeringOffset - 25;
  const y = y1 - dashedLineMargin - linkMarginY + centeringOffset;

  const [rotatedX, rotatedY] = rotate(
      x + linkWidth / 2,
      y + linkHeight / 2,
      centerX,
      centerY,
      angle,
  );
  return [
    rotatedX - linkWidth / 2,
    rotatedY - linkHeight / 2,
    linkWidth,
    linkHeight,
  ];
};

export const isPointHittingLinkIcon = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
  [x, y]: Point,
) => {
  const threshold = 4 / appState.zoom.value;
  const [x1, y1, x2, y2] = getElementAbsoluteCoords(element);
  const [linkX, linkY, linkWidth, linkHeight] = getLinkHandleFromCoords(
    [x1, y1, x2, y2],
    element.angle,
    appState,
  );
  const hitLink =
    x > linkX - threshold &&
    x < linkX + threshold + linkWidth &&
    y > linkY - threshold &&
    y < linkY + linkHeight + threshold;
  return hitLink;
};

export const isPointHittingVideoNotesIcon = (
    element: NonDeletedExcalidrawElement,
    appState: AppState,
    [x, y]: Point,
) => {
  const threshold = 4 / appState.zoom.value;
  const [x1, y1, x2, y2] = getElementAbsoluteCoords(element);
  const [commentX, commentY, commentWidth, commentHeight] =
      getVideoNotesHandleFromCoords([x1, y1, x2, y2], element.angle, appState);

  const hitComment =
      x > commentX - threshold &&
      x < commentX + threshold + 0 &&
      y > commentY - threshold &&
      y < commentY + 0 + threshold;

  return hitComment;
};

export const isPointHittingLink = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
  [x, y]: Point,
  isMobile: boolean,
) => {
  if (!element.link || appState.selectedElementIds[element.id]) {
    return false;
  }
  const threshold = 4 / appState.zoom.value;
  if (
    !isMobile &&
    appState.viewModeEnabled &&
    isPointHittingElementBoundingBox(element, [x, y], threshold, null)
  ) {
    return true;
  }
  return isPointHittingLinkIcon(element, appState, [x, y]);
};

export const isPointHittingVideoNotes = (
    element: NonDeletedExcalidrawElement,
    appState: AppState,
    [x, y]: Point,
    isMobile: boolean,
) => {
  return isPointHittingVideoNotesIcon(element, appState, [x, y]);
};

let HYPERLINK_TOOLTIP_TIMEOUT_ID: number | null = null;
export const showHyperlinkTooltip = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
) => {
  if (HYPERLINK_TOOLTIP_TIMEOUT_ID) {
    clearTimeout(HYPERLINK_TOOLTIP_TIMEOUT_ID);
  }

  /*
  HYPERLINK_TOOLTIP_TIMEOUT_ID = window.setTimeout(
    () => renderTooltip(element, appState),
    HYPERLINK_TOOLTIP_DELAY,
  );

   */
};

const renderTooltip = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
) => {
  if (!element.link) {
    return;
  }

  const tooltipDiv = getTooltipDiv();

  tooltipDiv.classList.add("excalidraw-tooltip--visible");
  tooltipDiv.style.maxWidth = "20rem";
  tooltipDiv.textContent = element.link;

  const [x1, y1, x2, y2] = getElementAbsoluteCoords(element);

  const [linkX, linkY, linkWidth, linkHeight] = getLinkHandleFromCoords(
    [x1, y1, x2, y2],
    element.angle,
    appState,
  );

  const linkViewportCoords = sceneCoordsToViewportCoords(
    { sceneX: linkX, sceneY: linkY },
    appState,
  );

  updateTooltipPosition(
    tooltipDiv,
    {
      left: linkViewportCoords.x,
      top: linkViewportCoords.y,
      width: linkWidth,
      height: linkHeight,
    },
    "top",
  );
  trackEvent("hyperlink", "tooltip", "link-icon");

  IS_HYPERLINK_TOOLTIP_VISIBLE = true;
};
export const hideHyperlinkToolip = () => {
  if (HYPERLINK_TOOLTIP_TIMEOUT_ID) {
    clearTimeout(HYPERLINK_TOOLTIP_TIMEOUT_ID);
  }
  if (IS_HYPERLINK_TOOLTIP_VISIBLE) {
    IS_HYPERLINK_TOOLTIP_VISIBLE = false;
    getTooltipDiv().classList.remove("excalidraw-tooltip--visible");
  }
};

export const shouldHideLinkPopup = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
  [clientX, clientY]: Point,
): Boolean => {
  const { x: sceneX, y: sceneY } = viewportCoordsToSceneCoords(
    { clientX, clientY },
    appState,
  );

  const threshold = 15 / appState.zoom.value;
  // hitbox to prevent hiding when hovered in element bounding box
  if (
    isPointHittingElementBoundingBox(element, [sceneX, sceneY], threshold, null)
  ) {
    return false;
  }
  const [x1, y1, x2] = getElementAbsoluteCoords(element);
  // hit box to prevent hiding when hovered in the vertical area between element and popover
  if (
    sceneX >= x1 &&
    sceneX <= x2 &&
    sceneY >= y1 - SPACE_BOTTOM &&
    sceneY <= y1
  ) {
    return false;
  }
  // hit box to prevent hiding when hovered around popover within threshold
  const { x: popoverX, y: popoverY } = getCoordsForPopover(element, appState);

  if (
    clientX >= popoverX - threshold &&
    clientX <= popoverX + CONTAINER_WIDTH + CONTAINER_PADDING * 2 + threshold &&
    clientY >= popoverY - threshold &&
    clientY <= popoverY + threshold + CONTAINER_PADDING * 2 + CONTAINER_HEIGHT
  ) {
    return false;
  }
  return true;
};
